import { connect } from 'react-redux';

import CityReport from '../../components/AR/CityReport/cityReport';
import { resetCityReport } from '../../actions/arap_actions';

function mapStateToProps(state) {
  return {
    cityReportLines: state.arap.cityReport.reportData,
    cityReportIsLoading: state.arap.cityReport.cityReportIsLoading,
    cityReportError: state.arap.cityReport.cityReportError,
  };
}

export default connect(mapStateToProps, {
  resetCityReport,
})(CityReport);



// WEBPACK FOOTER //
// ./master/jsx/containers/AR/cityReport.jsx